import { Tooltip } from 'react-tooltip'
import { LogoutIcon } from 'src/assets/icons/customIcons/menu-icons/Logout'
import { actionProps } from 'src/helpers/fns'
import { useAuthActions } from 'src/hooks/auth/auth'
import { useAuth } from 'src/hooks/auth/authObservableValue'
import { useTranslatable } from 'src/hooks/locale/utils'
import { useTheme } from 'src/state/providers/Theme'

export default function FinishEmulation() {
  const actions = useAuthActions()
  const auth = useAuth()
  const isEmulation = auth?.user?.emulatedBy != null
  const t = useTranslatable()
  const theme = useTheme()

  if (!isEmulation) {
    return null
  }

  return (
    <li
      data-tooltip-id={`emulate-user`}
      {...actionProps(() => void actions.FINISH_EMULATION())}
      className="mr-4 flex cursor-pointer"
    >
      <Tooltip id={`emulate-user`} place="top" variant={theme === 'dark' ? 'dark' : 'light'} className="mb-1 p-1">
        {t('system:return_to_real_profile')}
      </Tooltip>
      <LogoutIcon className="rotate-180" />
    </li>
  )
}
